var map = {
	"./banner_shopee.svg": 86,
	"./g_Vector.svg": 87,
	"./havecard-1.svg": 88,
	"./havecard-2.svg": 89,
	"./havecard-3.svg": 90,
	"./havecard-4.svg": 91,
	"./icon-facebook.svg": 20,
	"./icon-instagram.svg": 21,
	"./icon-linkedin.svg": 22,
	"./jakarta-gray.svg": 92,
	"./jakarta.svg": 93,
	"./kualaLumpur-gray.svg": 94,
	"./kualaLumpur.svg": 95,
	"./left_empty_triangle.svg": 23,
	"./left_triangle.svg": 96,
	"./manila-gray.svg": 97,
	"./manila.svg": 98,
	"./shenzhen-gray.svg": 99,
	"./shenzhen.svg": 100,
	"./shopee_white.svg": 101,
	"./singapore-gray.svg": 102,
	"./singapore.svg": 103,
	"./taiwan-gray.svg": 104,
	"./taiwan.svg": 105,
	"./teams-dev-commer.svg": 106,
	"./teams-intelligence.svg": 107,
	"./teams-marketing.svg": 108,
	"./teams-operations.svg": 109,
	"./thailand-gray.svg": 110,
	"./thailand.svg": 111,
	"./them_arrow.svg": 24,
	"./triangle_1.png": 112,
	"./two_red_triangle.svg": 113,
	"./two_session_triangle.svg": 25,
	"./two_triangle_xie.svg": 114,
	"./vietnam-gray.svg": 115,
	"./vietnam.svg": 116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;